// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__184hy","actions":"GroupTable_actions__qy8dk","deleteModalFooter":"GroupTable_deleteModalFooter__1jHxl"};